import { cloneDeep } from 'lodash';
import { resolversNames as dataLayerResolversNames } from '~/src/plugins/nuxt/dataLayer';
import { types as cartMutations } from '~/store/cart2/mutations';
import helperCartFindItemByIndex from '~/src/utils/helpers/cart/cartFindItemById';

/**
 * This plugin subscribe to store mutations and prepare data to handle datalayer.
 *
 * @param {Object} store
 *
 * @return {undefined}
 */
export default function (store) {
    let cartItemsBeforeChange = cloneDeep(store.state.cart2.items);

    store.subscribe(({ type, payload }, state) => {
        /**
         * Mutation increase or decrease product/cart item quantity
         */
        if (type.replace('cart2/', '') === cartMutations.SET_ITEM_QTY) {
            const productDataBeforeChange = helperCartFindItemByIndex(payload.id, cartItemsBeforeChange);

            if (productDataBeforeChange) {
                const { qty: qtyToSet } = payload;
                const { quantity: qtyBeforeChange } = productDataBeforeChange;

                if (qtyBeforeChange !== qtyToSet) {
                    const price = (productDataBeforeChange.price && productDataBeforeChange.price.value)
                        ? `${productDataBeforeChange.price.value}`
                        : '0';

                    /**
                     * Run nuxt plugin which push data to dataLayer
                     */
                    store.$dataLayer({
                        type: qtyToSet > qtyBeforeChange
                            ? dataLayerResolversNames.CART_ADD_ITEM
                            : dataLayerResolversNames.CART_REMOVE_ITEM,
                        data: {
                            product: {
                                ...productDataBeforeChange,
                                price,
                                quantity: qtyToSet > qtyBeforeChange
                                    ? qtyToSet - qtyBeforeChange
                                    : qtyBeforeChange - qtyToSet,
                            },
                        },
                    });
                }
            }
        }

        /**
         * Mutation delete item from cart
         */
        if (type.replace('cart2/', '') === cartMutations.DELETE_ITEM) {
            const productDataBeforeChange = helperCartFindItemByIndex(payload.id, cartItemsBeforeChange);

            if (productDataBeforeChange) {
                /**
                 * Run nuxt plugin which push data to dataLayer
                 */
                store.$dataLayer({
                    type: dataLayerResolversNames.CART_REMOVE_ITEM,
                    data: {
                        product: productDataBeforeChange,
                    },
                });
            }
        }

        cartItemsBeforeChange = cloneDeep(state.cart2.items);
    });
}
